var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 15.247,
    viewBox: "0 0 26 15.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5748",
    "data-name": "Group 5748",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    x2: 24,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    x2: 24,
    transform: "translate(0 6.624)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x2: 24,
    transform: "translate(0 13.247)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.990c55570264eb0e0d711c90990088ee.svg";
export { ForwardRef as ReactComponent };